module.exports = __webpack_public_path__ + "static/img/copy.c7b02ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article_3/portrait/copy.png
// module id = /MB7
// module chunks = 1